import { EWeightUnit } from 'src/enums/mixed.enum';

export const convertMeasurement = (
  convertion: 'kgToLbs' | 'kgToG' | 'kgToMetricTon' | 'lbsToOz' | 'lbsToUsTon' | 'mToKm' | 'kphToKn',
  amount: number,
) => {
  let resultAmount: number = 0;
  switch (convertion) {
    case 'kgToLbs':
      resultAmount = amount * 2.20462262185;
      break;
    case 'kgToG':
      resultAmount = amount * 1000;
      break;
    case 'kgToMetricTon':
      resultAmount = amount / 1000;
      break;
    case 'lbsToOz':
      resultAmount = amount * 16;
      break;
    case 'lbsToUsTon':
      resultAmount = amount / 2000;
      break;
    case 'mToKm':
      resultAmount = amount / 1000;
      break;
    case 'kphToKn':
      resultAmount = amount / 1.85;
      break;
    default:
      break;
  }
  return resultAmount;
};

export const getProperWeightText = (type: EWeightUnit, amount: number) => {
  let weightText = '';
  if (type === EWeightUnit.Metric) {
    if (amount < 1) {
      weightText = `${convertMeasurement('kgToG', amount).toLocaleString()} G`;
    } else if (convertMeasurement('kgToMetricTon', amount) >= 1) {
      weightText = `${convertMeasurement('kgToMetricTon', amount).toLocaleString()} T`;
    } else {
      weightText = `${amount.toLocaleString()} KG`;
    }
  } else if (type === EWeightUnit.US) {
    if (amount < 1) {
      weightText = `${convertMeasurement('lbsToOz', amount).toLocaleString()} Oz`;
    } else if (convertMeasurement('lbsToUsTon', amount) >= 1) {
      weightText = `${convertMeasurement('lbsToUsTon', amount).toLocaleString()} T`;
    } else {
      weightText = `${amount.toLocaleString()} Lbs`;
    }
  }
  return weightText;
};

export const getProperDistanceText = (amount: number) => {
  let distanceText = '';
  if (convertMeasurement('mToKm', amount) >= 1) {
    distanceText = `${convertMeasurement('mToKm', amount).toLocaleString()} km`;
  } else {
    distanceText = `${amount.toLocaleString()} m`;
  }

  return distanceText;
};

export const latLongToDmsConverter = (location: number) => {
  const sign = location >= 0 ? 1 : -1;
  location = Math.abs(location);

  const degree = Math.floor(location);
  const minuteDecimal = (location - degree) * 60;
  const minDegree = Math.floor(minuteDecimal);
  const secDegree = Number(((minuteDecimal - minDegree) * 60).toFixed(1));

  return {
    degree: degree * sign,
    minDegree,
    secDegree,
  };
};

export const DmsToLatLongConverter = (degObject: { degree: number; minute: number; second: number }) => {
  const sign = degObject.degree >= 0 ? 1 : -1;
  const deg = Math.abs(degObject.degree);

  const sum = (deg + degObject.minute / 60 + degObject.second / 3600) * sign;
  return sum;
};
